export default {
  viewAll: '查看全部',
  clearHistory: '清除歷史記錄',
  noGamesAvailable: '此類別中沒有找到任何遊戲。請稍後再來查看或瀏覽其他類別。',
  showMore: '顯示更多',
  showLess: '收起',
  loading: '載入中...',
  error: '發生錯誤，請重試。',
  retry: '重試',
  submit: '提交',
  cancel: '取消',
  confirm: '確認',
  save: '儲存',
  delete: '刪除',
  edit: '編輯',
  close: '關閉',
  back: '返回',
  next: '下一步',
  searchPlaceholder: '搜尋遊戲...',
  search: '搜尋',
  backToTop: '回到頂部',
  noMoreGames: '沒有更多遊戲了'
}; 